// Client-side mirror of netlify/lib/validate.mjs — keep the two in sync. Used to
// give the teacher a friendly heads-up before she submits; the server re-checks.

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim());
}

const DOMAIN_FIXES: Record<string, string> = {
  'gmail.con': 'gmail.com', 'gmail.co': 'gmail.com', 'gmial.com': 'gmail.com',
  'gmai.com': 'gmail.com', 'gmail.cm': 'gmail.com', 'gnail.com': 'gmail.com',
  'yaho.com': 'yahoo.com', 'yahoo.con': 'yahoo.com', 'yahoo.co': 'yahoo.com',
  'hotmial.com': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmail.co': 'hotmail.com',
  'outlook.con': 'outlook.com', 'outlook.co': 'outlook.com', 'iclould.com': 'icloud.com',
};

const TLD_FIXES: Record<string, string> = {
  con: 'com', cm: 'com', vom: 'com', comm: 'com', cimm: 'com', cet: 'com',
  ord: 'org', og: 'org', orgg: 'org', ogr: 'org',
  ne: 'net', nett: 'net', met: 'net',
  eduu: 'edu', eddu: 'edu',
};

export function suggestEmailFix(email: string): string | null {
  const e = (email || '').trim().toLowerCase();
  if (!e.includes('@')) return null;
  const [local, domain] = e.split('@');
  if (!local || !domain) return null;

  if (DOMAIN_FIXES[domain]) return `${local}@${DOMAIN_FIXES[domain]}`;

  const parts = domain.split('.');
  const tld = parts[parts.length - 1];
  if (TLD_FIXES[tld]) {
    parts[parts.length - 1] = TLD_FIXES[tld];
    return `${local}@${parts.join('.')}`;
  }
  return null;
}
